<template>
  <div>
    <!-- 订单结算 -->
    <template v-if="type === 'selected'">
      <div class="coupon-list-availability"
        :class="{ 'coupon-blue': coupon.couponType == '01', 'coupon-green': coupon.couponType == '02', 'coupon-red': coupon.couponType == '03' }">
        <div class="coupon-list-box">
          <div class="coupon-list-left">
            <div class="coupon-list-text  font-large" v-if="coupon.couponType == '01'">
              积分值：{{ coupon.obtainPointValue }}
            </div>
            <div class="coupon-list-text font-large" v-if="coupon.couponType === '02'">
              <div class="color-red"><span style="font-size:18px">减</span> <span style="font-size:30px">{{
                coupon.deductPointValue
              }}</span> </div>
              <div> 满{{ coupon.deductPointLimit }}{{ coupon.pointTypeName }}</div>
            </div>
            <div v-if="coupon.couponType === '03'">
              <div class="coupon-list-text  font-large color-red"
                v-if="coupon.couponType === '03' && coupon.exchangeRatio !== 0">
                <span style="font-size:12px">{{ coupon.limitItemCode }} </span>
                <span style="font-size:19px">{{ coupon.exchangeRatio * 10 }}折券</span>
              </div>
              <div class="coupon-list-text  font-large color-red "
                v-if="coupon.couponType === '03' && coupon.exchangeRatio === 0">
                <div style="font-size:12px">{{ coupon.limitItemCode }} </div>
                <div style="font-size:18px" class="margin-top">赠送券</div>
              </div>
            </div>
          </div>
          <div class="coupon-list-right">
            <div class="list-left">
              <div class="coupon-list-text font-large margin-y">券码：{{ coupon.couponCode }}</div>
              <div v-if="coupon.couponType === '01'" class="exchange-point margin-y">
                <span>{{ coupon.pointTypeName }}</span>
                <span v-if="coupon.couponStatus === '02'" class="exchange-button"
                  @click="exchangePoint(coupon)">兑换积分</span>
              </div>
              <div v-if="coupon.couponType === '02' && coupon.limitCategoryName" class="margin-y">使用范围：{{
                coupon.limitCategoryName
              }}</div>
              <div v-if="coupon.couponType === '02' && !coupon.limitCategoryName" class="margin-y">使用范围：全场通用</div>
              <div v-if="coupon.couponType === '03'" class="margin-y exchange-point">
                <span class="point-span" v-if="coupon.limitItemId !== '-1' && coupon.couponStatus === '02'">礼品名称:{{
                  coupon.limitItemName
                }}</span>
                <span class="point-span" v-if="coupon.limitItemId !== '-1' && coupon.couponStatus !== '02'">礼品名称:{{
                  coupon.limitItemName
                }}</span>
                <span v-if="coupon.limitItemId === '-1'">通用券(仅针对易加积分商品)</span>
              </div>
              <div class="margin-y">{{ coupon.generateTime | parseTime('{y}.{m}.{d}') }} - {{
                coupon.expireDate |
                  parseTime('{y}.{m}.{d}')
              }}</div>
            </div>
            <div class="list-right">
              <van-checkbox class="coupon-list-text color-000 margin-top margin-left"
                v-model="coupon.ischeck"></van-checkbox>
              <div><span class="line-height">×{{ coupon.couponCount }}</span></div>
            </div>
          </div>
        </div>
        <div class="txt-r coupon-list-text coupon-count font-large">
        </div>
        <div class="coupon-list-text color-000">
        </div>
      </div>
    </template>
    <!-- 我的卡券 线上 -->
    <template v-if="type === 'online'">
      <div class="coupon-list-availability"  @click="exchangePoint(coupon)"   :class="{
        'coupon-blue': coupon.couponType == '01', 'coupon-green': coupon.couponType == '02', 'coupon-red': coupon.couponType == '03' || coupon.couponType == '04',
        'coupon-old': model.onlineActiveIndex === '03', 'coupon-timeout': model.onlineActiveIndex === '04'
      }">
        <div class="coupon-list-box" @click="directBuy(coupon)" >
          <div class="coupon-list-left">
            <div v-if="coupon.couponType == '01'">
              <div class="coupon-list-text  font-large color-red"
                v-if="model.onlineActiveIndex !== '03' && model.onlineActiveIndex !== '04'">
                <div style="font-size:18px">{{ coupon.obtainPointValue }}</div>
                <div style="font-size:16px ;margin-top:6px;">积分值</div>
              </div>
              <div class="coupon-list-text  font-large " v-else>
                <div style="font-size:18px ;margin-top:6px;">{{ coupon.obtainPointValue }}</div>
                <div style="font-size:16px">积分值</div>
              </div>
            </div>
            <div class="coupon-list-text font-large" v-if="coupon.couponType === '02'">
              <div class="color-red" v-if="model.onlineActiveIndex !== '03' && model.onlineActiveIndex !== '04'"><span
                  style="font-size:18px">减</span> <span style="font-size:30px">{{
                    coupon.deductPointValue
                  }}</span> </div>
              <div v-else><span style="font-size:18px">减</span> <span style="font-size:30px">{{
                coupon.deductPointValue
              }}</span> </div>
              <div> 满{{ coupon.deductPointLimit }}{{ coupon.pointTypeName }}</div>
            </div>
            <div v-if="coupon.couponType === '03'">
              <div v-if="coupon.exchangeRatio !== 0">
                <div class="coupon-list-text  font-large color-red"
                  v-if="model.onlineActiveIndex !== '03' && model.onlineActiveIndex !== '04'">
                  <span style="font-size:12px">{{ coupon.limitItemCode }} </span>
                  <span style="font-size:19px">{{ coupon.exchangeRatio * 10 }}折券</span>
                </div>
                <div class="coupon-list-text  font-large " v-else>
                  <div style="font-size:12px ; margin-bottom: 10px;">{{ coupon.limitItemCode }} </div>
                  <div style="font-size:19px">{{ coupon.exchangeRatio * 10 }}折券</div>
                </div>
              </div>
              <div v-if="coupon.exchangeRatio === 0">
                <div class="coupon-list-text  font-large color-red"
                  v-if="model.onlineActiveIndex !== '03' && model.onlineActiveIndex !== '04'">
                  <div style="font-size:12px ; margin-bottom: 10px;">{{ coupon.limitItemCode }} </div>
                  <div style="font-size:18px">赠送券</div>
                </div>
                <div class="coupon-list-text  font-large " v-else>
                  <div style="font-size:12px ; margin-bottom: 10px;">{{ coupon.limitItemCode }} </div>
                  <div style="font-size:18px">赠送券</div>
                </div>
              </div>
            </div>
            <div v-if="coupon.couponType == '04'">
              <div class="coupon-list-text  font-large color-red"
                  v-if="model.onlineActiveIndex !== '03' && model.onlineActiveIndex !== '04'">
                  <div style="font-size:12px ; margin-bottom: 10px;">{{ coupon.limitItemCode }} </div>
                  <div style="font-size:18px">维保券</div>
                </div>
                <div class="coupon-list-text  font-large " v-else>
                  <div style="font-size:12px ; margin-bottom: 10px;">{{ coupon.limitItemCode }} </div>
                  <div style="font-size:18px">维保券</div>
                </div>
            </div>
          </div>

          <div class="coupon-list-right">
            <div class="list-left">
              <div class="coupon-list-text font-large margin-y">券码：{{ coupon.couponCode }}</div>
              <div v-if="coupon.couponType === '01'" class="exchange-point margin-y">
                <span>{{ coupon.pointTypeName }}</span>
                <!-- <van-button v-if="coupon.couponStatus === '02'&& coupon.couponType === '01'" class="exchange-button" size="mini" type="primary" plain
                  @click="exchangePoint(coupon.couponId)">兑换积分</van-button> -->
              </div>
              <div v-if="coupon.couponType === '02' && coupon.limitCategoryName" class="margin-y">使用范围：{{
                coupon.limitCategoryName
              }}</div>
              <div v-if="coupon.couponType === '02' && !coupon.limitCategoryName" class="margin-y">使用范围：全场通用</div>
              <div v-if="coupon.couponType === '03'" class="margin-y exchange-point">
                <span class="point-span" v-if="coupon.limitItemId !== '-1' && coupon.couponStatus === '02'">礼品名称:{{
                  coupon.limitItemName
                }}</span>
                <span v-if="coupon.limitItemId !== '-1' && coupon.couponStatus !== '02'" class="point-span">礼品名称:{{
                  coupon.limitItemName
                }}</span>
                <span v-if="coupon.limitItemId === '-1'">通用券(仅针对易加积分商品)</span>
              </div>
              <div v-if="coupon.couponType === '04'" class="margin-y exchange-point">
                <span class="point-span" v-if="coupon.limitItemId !== '-1' && coupon.couponStatus === '02'">礼品名称:{{
                  coupon.limitItemName
                }}</span>
                <span v-if="coupon.limitItemId !== '-1' && coupon.couponStatus !== '02'" class="point-span">礼品名称:{{
                  coupon.limitItemName
                }}</span>
              </div>
              <div class="margin-y">{{ coupon.generateTime | parseTime('{y}.{m}.{d}') }} - {{
                coupon.expireDate |
                  parseTime('{y}.{m}.{d}')
              }}</div>
            </div>
            <div class="list-right">
              <div class="line-height2">
                <span>×{{ coupon.couponCount }}</span>
              </div>
              <div v-if="coupon.couponStatus === '02' && coupon.exchangeRatio === 0" class="exchange-button"><span style="font-size:12px;">点击使用></span></div>
              <div v-if="coupon.couponStatus === '02' && coupon.couponType == '04'" class="exchange-button"><span style="font-size:12px;">点击使用></span></div>
              <div v-if="coupon.couponType == '01' && model.onlineActiveIndex !== '03' && model.onlineActiveIndex !== '04'" class="exchange-button"><span style="font-size:12px;">兑换积分></span></div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 我的卡券 vip -->
    <!-- <template v-if="type === 'vip' && vipCardInfo">
      <div class="coupon-list-availability vip-coupon">
        <div class="coupon-list-vip vip-coupon-text font-large" style="padding-top: 0.76rem;">{{ vipCardInfo.cardName }}
        </div>
        <div class="coupon-list-vip txt-r vip-coupon-text font-large">{{ vipCardInfo.exchangeRatio * 10 }}折卡</div>
        <div class="coupon-list-vip txt-r vip-coupon-text">
          {{ vipCardInfo.generateTime | parseTime('{y}-{m}-{d}') }}~{{ vipCardInfo.expireDate | parseTime('{y}-{m}-{d}')
          }}
        </div>
      </div>
    </template> -->
    <!-- 我的卡券 线下 -->
    <!-- <template v-if="type === 'offline'">
      <div class="coupon-list-availability" :class="{
        'coupon-blue': coupon.couponType == '01', 'coupon-green': coupon.couponType == '02', 'coupon-red': coupon.couponType == '03',
        'coupon-old': model.onlineActiveIndex === '03', 'coupon-timeout': model.onlineActiveIndex === '04'}">
        <div class="coupon-list-text font-large">券码：{{ coupon.couponCode }}</div>
        <div class="coupon-list-text font-large">截止日期: {{ coupon.couponExpireTime }}</div>
        <div class="coupon-list-text font-large">活动名称: {{ coupon.eventName }}</div>
      </div>
    </template> -->
  </div>
</template>

<script>
import couponApi from '@/api/coupon'
import cartApi from '@/api/cart'
export default {
  props: {
    coupon: {
      type: Object,
      default: () => { }
    },
    type: { // vip,offline,online,selected
      type: String,
      default: 'selected'
    },
    model: {
      type: Object,
      default: () => { }
    }
    // vipCardInfo: {
    //   type: Object,
    //   default: () => { }
    // }
  },
  components: {},
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    // 兑换积分
    exchangePoint (coupon) {
      if (coupon.couponStatus === '02' && coupon.couponType === '01') {
        let couponId = coupon.couponId
        this.$dialog.alert({
          message: `你确定要兑换吗?`,
          title: '兑换积分',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          couponApi.obtainPoint({ couponId }).then(res => {
            if (res.data.resultCode === '0') {
              this.$dialog.alert({
                message: '兑换成功，兑换' + res.data.resultData.pointValue + '(' + res.data.resultData.pointTypeName + ')',
                title: '恭喜你'
              }).then(() => {
                this.$emit('getCouponList')
              })
            }
          })
        }).catch(() => { })
      }
    },
    directBuy (coupon) {
      if (this.model.onlineActiveIndex === '03') {
        return
      }
      if (this.model.onlineActiveIndex === '04') {
        return
      }
      if (this.type !== 'online') {
        return
      }
      if (coupon.couponType === '04') {
        this.$dialog.alert({
          message: '请前往BOSCH易+小程序兑换'
        }).then((res) => {
          console.log(res)
        })
        return
      }
      if (coupon.couponType !== '03') {
        return
      }
      if (coupon.isGroupItemCoupon === 1) {
        this.$router.push({
          name: 'goods-detail',
          query: {
            itemId: coupon.limitItemId,
            couponId: coupon.couponId
          }
        })
      } else {
        const payload = {
          itemQuantity: 1,
          itemId: coupon.limitItemId,
          couponId: coupon.couponId
        }
        cartApi.queryCartBuy(payload).then(res => {
          if (res.data.resultCode === '0') {
            this.$router.push({
              name: 'direct_buy',
              query: {
                itemId: coupon.limitItemId,
                couponId: coupon.couponId
              }
            })
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.coupon-list-availability {
  height: 2.77rem;
  width: 100%;
  position: relative;
  margin: 0.2rem 0rem;
  color: #666666;
  font-size: 0.3rem;
}

.coupon-list-box {
  height: 2.77rem;
  display: flex;
  justify-content: flex-start;

  .coupon-list-left {
    width: 120px;
    height: 44px;
    text-align: center;
    margin-top: 30px;
  }

  .coupon-list-right {
    width: 210px;
    height: 2.77rem;
    display: flex;
    justify-content: space-between;
    margin-left: 10px;

    .list-left {
      width: 270px;
      margin-top: 25px;

      .exchange-point {
        flex-wrap: nowrap;
        display: flex;
        flex: 1;
        align-items: center;
        width: 100%;

        .point-span {
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 170px;
          overflow: hidden;
        }

        button {
          font-weight: 500;
        }
      }

      .margin-y {
        margin-bottom: 8px;
      }
    }

    .list-right {
      position: relative;
      width: 40px;
      font-size: 20px;

      .exchange-button {
        line-height: 20px;
        height: 20px;
        width:70px;
        position: absolute;
        right: -15px;
        bottom: 25px;
      }

      .margin-left {
        margin-left: 10px;
        margin-top: 20px;
      }

      .line-height {
        line-height: 75px;
      }

      .line-height2 {
        line-height: 60px;
      }
    }
  }
}
.coupon-list-vip {
  height: 0.6rem;
  padding: 0.2rem 0.76rem;
}

.coupon-count {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.coupon-list-checkbox {
  position: absolute;
  bottom: 0.45rem;
  left: 0.55rem;
  color: black;
  font-size: 0.4rem;
}

.exchange-point {
  flex-wrap: nowrap;
  display: flex;
  flex: 1;
  align-items: center;
  width: 100%;

  .point-span {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 220px;
    overflow: hidden;
  }

  button {
    font-weight: 500;
  }
}

.vip-coupon-text {
  color: #fae862;
  font-family: 'Microsoft Yahei', sans-serif;
  font-weight: 600;
  font-style: italic;
}

.coupon-green {
  background: url(../assets/images/coupon/no-use.png) no-repeat;
  background-size: cover;
}

.coupon-red {
  background: url(../assets/images/coupon/pink.png) no-repeat;
  background-size: contain;
}

.coupon-blue {
  background: url(../assets/images/coupon/pink.png) no-repeat;
  background-size: cover;
}

.coupon-old {
  background: url(../assets/images/coupon/use.png) no-repeat;
  background-size: cover;
}

.coupon-timeout {
  background: url(../assets/images/coupon/overdue.png) no-repeat;
  background-size: cover;
}

.vip-coupon {
  background: url(https://wx.bosch-extra.com.cn/img/coupon-vip.png);
  background-size: cover;
}

// .txt-r {
//   text-align: right;
// }

.font-large {
  font-size: 12px;

}

.color-red {
  color: #FF0000;
  font-weight: 600;
  margin-bottom: 5px;
}

.margin-top {
  margin-top: 12px;
}

.color-000 {
  color: #000
}
</style>
